import React, { useEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import i18next from "i18next";

import Container from '@material-ui/core/Container';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Checkbox from '@material-ui/core/Checkbox';

import Loader from '../_shared/Loader';
import useList from '../hooks/useList';
import httpClient from '../_shared/HttpClient';

//store
import { appStore } from '../../appStore.js';
import { Typography } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    okButton: {
        color: theme.palette.info.main,
    },
}));

const UserRoles = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { id } = props;
    const { state, dispatch } = useContext(appStore);
    const [isLoading, setIsLoading, rows, setRows, hasMore, setHasMore, upsertRow, removeRow] = useList('name');
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        loadData();
    }, [id]);

    const loadData = async (append) => {
        if (isLoading || (!hasMore && append) || !id) return;
        setIsLoading(true);

        if (!append) {
            setRows([]);
        }
        try {
            var result = await httpClient('get', 'user/getRoles', { id: id });

            if (append) {
                setRows([...rows, ...result])
            }
            else {
                setRows(result);
            }
            setHasMore(false);
        }
        catch (err) {
            console.log(err);
        }
        finally {
            setIsLoading(false);
        }
    };

    const handleCheckBox = async (e, i, row, userID) => {
        e.preventDefault();

        if (isLoading) return;

        try {
            setIsLoading(true);

            //remove role
            if (userID) {
                const result = await httpClient('deletePost', 'user/RemoveUserRole', row);

                if (result.errors) {
                    // setErrors(result.errors);
                }
                else {
                    upsertRow(i, result);
                }
            }
            //add role
            else {
                const result = await httpClient('post', 'user/AddUserRole', { userID: id, roleID: row.roleID, roleName: row.roleName });

                if (result.errors) {
                    // setErrors(result.errors);
                }
                else {
                    upsertRow(i, result);
                }
            }
        }
        catch (e) {
            // setErrors([{ message: e }]);
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <Loader isLoading={isLoading}>
            <Container>

                {
                    (rows ? rows : []).map((x, i) =>
                        <List
                            key={i}
                            component="nav"
                        >
                            <ListItem
                                button
                                divider
                                onClick={() => setSelected(i)}
                            >
                                <ListItemText
                                    primary={
                                        <Typography noWrap>
                                            {x.roleName}
                                        </Typography>
                                    }
                                />
                                <ListItemSecondaryAction>
                                    <Checkbox
                                        edge="end"
                                        checked={x.userID != ''}
                                        onChange={(e) => handleCheckBox(e, i, x, x.userID)}

                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        </List>
                    )
                }
            </Container>
        </Loader >

    )
}
export default UserRoles
